import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import { getLogs as getLogsList, getLog as getLogApi } from "../../helpers/";

// constants
import { LogsActionTypes } from "./constants";
import {
  LogsGetListError,
  LogsGetListSuccess,
  getLogSuccess,
  getLogError,
} from "./actions";

interface LogData {
  payload: {
    limit: number;
    skip: number;
    keyword?: string;
    action?: string;
    entity?: string;
    user?: string;
    country?: string;
    startDate?: string;
    endDate?: string;
  };
  type: string;
}

interface GetLogData {
  payload: {
    id: string;
  };
  type: string;
}

function* getLogs({
  payload: {
    limit,
    skip,
    keyword,
    action,
    entity,
    user,
    country,
    startDate,
    endDate,
  },
}: LogData): SagaIterator {
  try {
    const response = yield call(getLogsList, {
      limit,
      skip,
      keyword,
      action,
      entity,
      user,
      country,
      startDate,
      endDate,
    });
    const Logs = response.data;
    yield put(LogsGetListSuccess(LogsActionTypes.GET_LIST_LOGS, Logs));
  } catch (error: any) {
    yield put(LogsGetListError(LogsActionTypes.GET_LIST_LOGS, error));
  }
}

function* getLog({ payload: { id } }: GetLogData): SagaIterator {
  try {
    const response = yield call(getLogApi, { id });
    const Log = response.data;
    yield put(getLogSuccess(LogsActionTypes.GET_LOG, Log));
  } catch (error: any) {
    const errorMessage =
      typeof error === "string" ? error : error.response.data;
    yield put(getLogError(LogsActionTypes.GET_LOG, errorMessage));
  }
}

export function* watchGetLogs() {
  yield takeEvery(LogsActionTypes.GET_LIST_LOGS, getLogs);
}

export function* watchGetLog() {
  yield takeEvery(LogsActionTypes.GET_LOG, getLog);
}

function* logsSaga() {
  yield all([fork(watchGetLogs), fork(watchGetLog)]);
}

export default logsSaga;
